import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IBoondock } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = BASE_API_URL + 'boondock';

/**
 * Local fork of @curbnturf/boondock-listing's BoondockService — trimmed to
 * plain HttpClient. Only fetch()/favorite()/unfavorite() are used; the real
 * class's create/update/search/preload/native-offline-cache surface isn't
 * needed here.
 */
@Injectable({ providedIn: 'root' })
export class BoondockApiService {
  private readonly http = inject(HttpClient);

  fetch(boondockId: number): Observable<IBoondock> {
    return this.http.get<IBoondock>(`${API_URL}/${boondockId}`);
  }

  favorite(boondock: IBoondock): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${API_URL}/${boondock.id}/favorite`, null);
  }

  unfavorite(boondock: IBoondock): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${API_URL}/${boondock.id}/unfavorite`, null);
  }
}
